import { render } from "./notFound.vue?vue&type=template&id=5504f3a7&scoped=true"
const script = {}

import "./notFound.vue?vue&type=style&index=0&id=5504f3a7&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5504f3a7"]])

export default __exports__